import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PasswordModule } from 'primeng/password';
import { PasswordInput } from '../../../models';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
    selector: 'lib-password-input',
    standalone: true,
    imports: [PasswordModule, FormsModule, ReactiveFormsModule, TranslateModule],
    template: `
        <p-password
            inputId="{{ 'input-' + name }}"
            [feedback]="control.feedback"
            [toggleMask]="control.toggleMask"
            [class]="control.inputClass.join(' ')"
            [placeholder]="control.placeholder! | translate"
            [formControl]="control"
        ></p-password>
    `
})
export class PasswordInputComponent extends BaseInputComponent {
    @Input() name!: string;
    @Input() override control!: PasswordInput;
}
